/**
 * Cart API for Third-Party Integrations
 * Exposes window.updateCart() method to trigger cart drawer refresh
 */

(function() {
  'use strict';

  // Wait for theme to be fully initialized
  function initCartAPI() {
    // Find the CartDrawer instance through the DOM
    var cartDrawerForm = document.querySelector('#CartDrawerForm');

    if (!cartDrawerForm) {
      console.warn('[Cart API] Cart drawer form not found');
      return;
    }

    /**
     * Triggers cart drawer to refresh and display updated items
     * Third-party apps should call this after programmatically modifying cart
     * @example window.updateCart();
     */
    window.updateCart = function() {
      try {
        // Trigger the cart:build event that the theme already listens for
        document.dispatchEvent(new CustomEvent('cart:build'));

        // Also trigger theme.cart.buildCart() if available
        if (window.theme && window.theme.cart && typeof window.theme.cart.buildCart === 'function') {
          window.theme.cart.buildCart();
        }
      } catch (error) {
        console.error('[Cart API] Error updating cart:', error);
      }
    };

    console.log('[Cart API] window.updateCart() is now available');
  }

  // Initialize when DOM is ready and theme is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Add small delay to ensure theme.js has initialized
      setTimeout(initCartAPI, 100);
    });
  } else {
    // DOM already loaded
    setTimeout(initCartAPI, 100);
  }
})();
